import React, { useState, useEffect } from 'react';
import StyledDatePicker from './DatePicker';
import StyledTimePicker from './TimePicker';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import debug from 'debug';
import Stack from '@mui/material/Stack';
import moment, { Moment } from 'moment';
import Typography from '@mui/material/Typography';

const d = debug('formDialog');

interface DateTimeComboFieldProps {
  value: Moment;
  onChange: (newValue: any) => void;
}

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      padding: `0 ${theme.spacing(1)}`,
      '& .rc-time-picker': {
        marginTop: theme.spacing(0),
      },
    },
    container: {},
    sendTimeLabel: {},
    errorText: {
      color: theme.palette.error.main,
      marginTop: theme.spacing(1),
    },
    sendDateLabel: {
      marginTop: theme.spacing(2),
    },
  }),
  { name: 'DateTimeComboField' },
);

const generateInitialDate = () => {
  var now = new Date();
  now.setDate(now.getDate() + 1);
  now.setHours(8);
  now.setMinutes(0);
  now.setMilliseconds(0);
  return moment(now).utc();
};

const DateTimeComboField: React.FC<DateTimeComboFieldProps> = ({ value, onChange }) => {
  const classes = useStyles();
  const minDeliveryTime = moment().add(15, 'minutes').utc();
  const [currentValue, setCurrentValue] = useState(value || generateInitialDate());
  const [errorStatus, setErrorStatus] = useState(false);

  const checkDeliveryTime = (scheduleDeliveryTime: Moment, minDeliveryTime: Moment) => {
    moment(scheduleDeliveryTime).isSameOrAfter(minDeliveryTime) ? setErrorStatus(false) : setErrorStatus(true);
  };

  const handleDateChange = (val: Moment) => {
    setCurrentValue(moment(val));
    checkDeliveryTime(val, minDeliveryTime);
  };

  const handleTimeChange = (val: Moment) => {
    setCurrentValue(moment(val));
    checkDeliveryTime(val, minDeliveryTime);
  };

  // when user click Send Now and then click back to Schedule send, we need to check the value
  useEffect(() => {
    checkDeliveryTime(currentValue, minDeliveryTime);
    // eslint-disable-next-line
  }, []);

  // Update the Field...
  useEffect(() => {
    if (value !== currentValue) {
      d('different', value, currentValue);
      onChange(currentValue.utc().utcOffset(600));
    }
  }, [value, currentValue, onChange]);

  const format = 'hh:mm A';
  return (
    <div className={classes.root}>
      <Stack>
        <Typography variant="subtitle1" className={classes.sendTimeLabel}>
          Send Time
        </Typography>
        <StyledTimePicker
          name="time"
          className="timePicker"
          // @ts-ignore
          popupStyle={{ zIndex: 1400 }}
          value={moment(currentValue, format)}
          onChange={handleTimeChange}
          errorStatus={errorStatus}
        />
        {errorStatus && (
          <Typography variant="subtitle1" className={classes.errorText}>
            Please select a time at least 15 minutes in the future
          </Typography>
        )}
        <Typography variant="subtitle1" className={classes.sendDateLabel}>
          Send Date
        </Typography>
        <StyledDatePicker value={moment(currentValue)} onChange={handleDateChange} minDate={new Date()} />
      </Stack>
    </div>
  );
};

export default DateTimeComboField;
